const moduleState = {
  quotes: [],
  showQuotesAcrossEstablishments: false,
  showColleagueQuotes: false,
  searchQuery: '',
  statusFilter: '',
}

const mutations = {
  setQuotes(state, payload) {
    state.quotes = payload
  },
  setFilterAllEstablishments(state, payload) {
    state.showQuotesAcrossEstablishments = payload
  },
  setFilterColleagueQuotes(state, payload) {
    state.showColleagueQuotes = payload
  },
  setFilterSearchQuery(state, payload) {
    state.searchQuery = payload
  },
  setFilterStatus(state, payload) {
    state.statusFilter = payload
  },
}

const actions = {
  addQuotes: ({ commit, state }, payload) => {
    let concatted = state.quotes.concat(payload)
    commit('setQuotes', concatted)
  },
  reset: ({ commit }) => {
    commit('setQuotes', [])
  },
}

export default {
  state: moduleState,
  mutations,
  actions,
  namespaced: true,
}
